import React from 'react';
import CardIncorporadoraStyled from './CardIncorporadoraStyled';

/**
 * items: [{ id, usuarioId, nome, imagem }]
 */
export default function ListaIncorporadoras({ items = [], onEdit, onDeleted }) {
  const dados = items.slice(0, 6); // ✅ limita a 6 cards

  return (
    <div
      className="
        grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6
        gap-4   /* ✅ espaçamento entre os cards */
      "
    >
      {dados.map((inc) => (
        <CardIncorporadoraStyled
          key={inc.id}
          id={inc.id}
          usuarioId={inc.usuarioId}
          nome={inc.nome}
          imagem={inc.imagem}
          onEdit={onEdit ? () => onEdit(inc) : undefined}
          onDeleted={onDeleted}
          size="md"
        />
      ))}
    </div>
  );
}
